import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';

import './Tooltip.scss';
import FontAwesome from 'react-fontawesome';

const Tooltip = ({ children }) => {
  const [isOpen, setOpen] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = event => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  });

  return (
    <div className="tooltip-wrapper" ref={wrapperRef}>
      <FontAwesome name="question" className="tooltip-toggle" onClick={() => setOpen(!isOpen)} />
      {isOpen && <div className="tooltip-contents">{children}</div>}
    </div>
  );
};

Tooltip.propTypes = {
  children: PropTypes.node,
};

export default Tooltip;
